import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IndexedDbService } from '../../core/services/indexed-dbservice.service';

@Pipe({
  name: 'customDate',
  standalone: true,
  pure: false
})
export class CustomDatePipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');
  private cachedFormat: string | null = null;

  constructor(private dbService: IndexedDbService) { }

  async getFormat(): Promise<any> {
    if (this.cachedFormat) return this.cachedFormat ?? 'dd/MM/yyyy';

    try {
      const siteData: any = await this.dbService.getData('websiteSetting');
      let format = siteData?.CompanyDateFormat || 'dd/MM/yyyy';
      format = format.replace(/YYYY/g, 'yyyy').replace(/YY/g, 'yy');
      this.cachedFormat = format;
      return this.cachedFormat;
    } catch {
      return 'dd/MM/yyyy';
    }
  }

  async transform(value: any): Promise<any> {
    if (!value) return '';
    const format = await this.getFormat();
    return this.datePipe.transform(value, format) ?? '';
  }

}
